import styled from 'styled-components';

import Button from '@/components/Button';

export const CloseButton = styled(Button)`
  margin-top: 24px;
  width: 459px;
  align-self: center;
`;
